/* eslint-disable global-require */
const { en: common } = require("../../common");

module.exports = {
	...common,
	"share-downloads": require("./share-downloads.json"),
	"share-downloads-links": require("./share-downloads-links.json"),
	"share-downloads-form": require("./share-downloads-form.json"),
};
